import AbstractWidget from "@/models/PlatinumWidget/AbstractWidget";
import PublicImage from "@/models/PublicImage/PublicImage";
import PlatinumWidget from "@/models/PlatinumWidget/PlatinumWidget";

export default class Photo extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/photo';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetPhotos';

    static model_name = 'Photo';

    static fields() {
        return {
            id: this.number(null).nullable(),
            is_full_height: this.boolean(null),
            vertical_public_image_id: this.number(null).nullable(),
            horizontal_public_image_id: this.number(null).nullable(),
            horizontal_image_x_position: this.number(null).nullable(),
            horizontal_image_y_position: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(PlatinumWidget, 'widgetable_id'),
            horizontalPublicImage: this.belongsTo(PublicImage, 'horizontal_public_image_id'),
            verticalPublicImage: this.belongsTo(PublicImage, 'vertical_public_image_id'),
        }
    }

    HorizontalPublicImage() {
        return this.getRelated('horizontalPublicImage');
    }

    VerticalPublicImage() {
        return this.getRelated('verticalPublicImage');
    }

    Widget() {
        return PlatinumWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
